import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { makeValidatorHook } from './use-validator';
const FormContext = createContext(null);
export const FormProvider = ({ validations, children, onSubmit, initialData, validateUndefined, ...props }) => {
    const [formData, setFormData] = useState(initialData ?? {});
    const useValidator = useMemo(() => makeValidatorHook(validations, { validateUndefined }), [validations]);
    const { validate, validationErrors, setValidationConfig } = useValidator(formData);
    const submitForm = useCallback((event) => {
        // prevent form from redirecting to a new page
        event?.preventDefault();
        const errors = validate(formData, { validateUndefined: true, setErrorsState: true });
        setValidationConfig((config) => ({ ...config, validateUndefined: true }));
        if (Object.keys(errors).length === 0) {
            onSubmit?.(formData, event);
        }
    }, [formData, onSubmit, setValidationConfig, validate]);
    // Reset form data when initial data changes
    useEffect(() => {
        setFormData(initialData ?? {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(initialData)]);
    const state = useMemo(() => ({
        validationErrors,
        formData: formData ?? {},
        setFormData,
        submitForm,
        validate,
    }), [validationErrors, formData, submitForm, validate]);
    return (_jsx(Box, { component: "form", ...props, onSubmit: submitForm, children: _jsx(FormContext.Provider, { value: state, children: children }) }));
};
export const useForm = () => {
    const state = useContext(FormContext);
    if (state === null)
        throw new Error('useForm must be used inside a Form component');
    return state;
};
